module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_14_m2.ecc1b548cbc18e012496f8d89983bf27.png";